import { Component,Inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'app/api.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LedgerBookDialogComponent } from 'app/ledger-book-dialog/ledger-book-dialog.component';

@Component({
  selector: 'app-voucher-breakdown-dialog',
  templateUrl: './voucher-breakdown-dialog.component.html',
  styleUrls: ['./voucher-breakdown-dialog.component.scss']
})
export class VoucherBreakdownDialogComponent {
   vouchers: any[] = [];
  
  loading = true;

  company_name: any;
  company_address: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,private dialog: MatDialog,
    private apiService: ApiService,
    private dialogRef: MatDialogRef<VoucherBreakdownDialogComponent>
  ) {}

  ngOnInit(): void {
  if (this.data.creationVoucherIds?.length) {
    this.fetchVoucherDetails();
  } else if (this.data.ledgerId) {
    this.fetchCreationVoucherIds();
  }
}
fetchCreationVoucherIds(): void {
  this.loading = true;
  this.apiService
    .getCreationVoucherIds(this.data.ledgerId,"Ledger")
    .subscribe({
      next: (response: any) => {
        this.data.creationVoucherIds =
          response.data || [];
        this.fetchVoucherDetails();
      },
      error: (error) => {
        console.error(error);
        this.loading = false;
      }
    });
}

  // fetchVoucherDetails() {
  //   this.apiService.getLedgerVoucherDetails(this.data.ledger_id)
  //     .subscribe(res => {
  //       this.vouchers = res || [];
  //       this.loading = false;
  //     });
  // }
  fetchVoucherDetails(): void {
  this.loading = true;
  this.apiService.getVoucherBreakdownByIds(
      this.data.creationVoucherIds,this.data.ledgerId,
    )
    .subscribe({
      next: (response: any) => {
        this.vouchers = response.data || [];
        this.loading = false;
      },
      error: (error) => {
        console.error(error);
        this.loading = false;
      }
    });
}
ledgerbookdetailsModal(voucher: any) {
this.apiService.getVoucherBookDetails(voucher.creation_voucher_id).subscribe({
  next: (response: any) => {
        const data = response.data;
        this.dialog.open(LedgerBookDialogComponent,
        {
            width: '800px',
            disableClose: true,
            data: {
              voucher_name:data.voucher_type,
              voucher_no:data.voucher_no,
              date:data.date,
              narration:data.narration || '',
              debits:data.debits || [],
              credits:data.credits || [],
              company_name:this.company_name,
              company_address:this.company_address,
              creation_voucher_id: data.creation_voucher_id
            }
          }
        );
      },
      error: (error) => {
        console.error(error);
      }
    });
}
  close() {
    this.dialogRef.close();
  }

}
